// assets/custom-countdown.js
document.addEventListener('DOMContentLoaded', function(){
  // find every t4s countdown wrapper
  document.querySelectorAll('[data-countdown-t4s]').forEach(wrapper=>{
    // 1) Normalize the date attribute so JS can parse it
    const raw = wrapper.getAttribute('data-date') || '';
    const iso  = raw.replace(/\//g,'-');
    wrapper.setAttribute('data-date', iso);
    // 2) force an English hint
    wrapper.setAttribute('lang','en');
  });

  // caching our countdowns
  const cbs = Array.from(
    document.querySelectorAll('.t4s-countdown .time')
  ).map(timeEl => Array.from(timeEl.children));

  // English labels we want
  const EN = ['Days','Hours','Minutes','Seconds'];

  // recalc and re-write every second
  function update() {
    const now = new Date();
    cbs.forEach(spans => {
      // date wrapper is parent → up one level: .t4s-countdown
      const wrapper = spans[0].closest('[data-countdown-t4s]');
      const target  = new Date(wrapper.getAttribute('data-date'));
      let diff = target - now;
      // handle looping if day-loop set
      const loopDays = parseInt(wrapper.getAttribute('data-dayl'))||0;
      if (diff < 0 && loopDays > 0) {
        const period = loopDays * 86400000;
        diff = ((diff % period) + period) % period;
      }
      if (diff < 0) diff = 0;

      const d = Math.floor(diff/86400000);
      const h = Math.floor(diff%86400000/3600000);
      const m = Math.floor(diff%3600000/60000);
      const s = Math.floor(diff%60000/1000);
      const vals = [d,h,m,s];

      spans.forEach((span,i)=>{
        const num = span.querySelector('.cd-number');
        const txt = span.querySelector('.cd-text');
        if (num) num.textContent = String(vals[i]).padStart(2,'0');
        if (txt) txt.textContent = EN[i];
      });
    });
  }

  update();
  setInterval(update, 1000);
});
